// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-41964054] {\n  margin: 1.2em 0;\n}\n.abn[data-v-41964054] {\n  width: 15ch;\n}\n.quoteNo[data-v-41964054] {\n  width: 15ch;\n}\n.subtext[data-v-41964054] {\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
